/** @internal */
export type FilterFieldState = {
  suggestions: Map<string, () => void>;
  activeSuggestion: number;
};

/** @internal */
export type SuggestionPayload = {
  /** The id of the suggestion. */
  id: string;
};

/** @internal */
export type AddSuggestionPayload = SuggestionPayload & {
  /** Callback to apply the selected suggestion's value. */
  applySuggestion: () => void;
};

/** @internal */
export const enum FilterFieldActions {
  ADDSUGGESTION = 'add',
  REMOVESUGGESTION = 'remove',
}

/** @internal */
export type FilterFieldReducerAction =
  | {
      type: FilterFieldActions.ADDSUGGESTION;
      payload: AddSuggestionPayload;
    }
  | {
      type: FilterFieldActions.REMOVESUGGESTION;
      payload: SuggestionPayload;
    };

/**
 * FilterField reducer function used to add / remove filter field suggestions.
 * @internal
 */
export function filterFieldReducer(
  state: FilterFieldState,
  action: FilterFieldReducerAction,
): FilterFieldState {
  const { type, payload } = action;

  const newState = { ...state };

  // ADD Suggestion
  if (type === FilterFieldActions.ADDSUGGESTION) {
    const { id, applySuggestion } = payload;
    newState.suggestions.set(id, applySuggestion);

    return newState;
  }

  // REMOVE Suggestion
  if (type === FilterFieldActions.REMOVESUGGESTION) {
    const { id } = payload;
    newState.suggestions.delete(id);

    return newState;
  }

  return state;
}
